import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ClarityService, GoogleAnalyticsService } from '@shared/analytics';
import { ENVIRONMENT_CONFIG } from '@shared/config';
import { AppUpdateService } from '@shared/services';
import { WalmartEnvironmentConfig } from '@walmart/config';

@Component({
  selector: 'walmart-us-root',
  imports: [RouterOutlet],
  templateUrl: './walmart-us.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WalmartUSComponent {
  private appUpdates = inject(AppUpdateService);
  private clarityService = inject(ClarityService);
  private googleAnalytics = inject(GoogleAnalyticsService);

  private envConfig = inject<WalmartEnvironmentConfig>(ENVIRONMENT_CONFIG);

  constructor() {
    this.clarityService.initialize(this.envConfig.clarityKey);
    this.googleAnalytics.initialize(this.envConfig.gaMeasurementId);
    this.appUpdates.start();
  }
}
